





































































import { Component, Vue, Prop } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import { SigninDto } from '../../../services/shared/auth/dto';
import AuthService from '../../../services/shared/auth/auth.service';
import JwtStorageService from '../../../services/shared/auth/jwt-storage.service';
import CompanyUserService from '../../../services/company-user.service';
import { CompanyUserDto, CompanyUserListDto } from '../../../dto';
import { IsValidatePhone, IsValidatePassword } from '../../../core';
import { Pagination } from '../../../common';

@Component({
  name: 'LoginLayout',
})
export default class LoginLayout extends BaseComponent {
  private signinDto = new SigninDto();
  // clear all parameters
  private clearOut() {
    this.signinDto = new SigninDto();
  }

  // TODO: phone and password validator
  signin() {
    AuthService.signin(this.signinDto).subscribe(res => {
      if (!res) {
        this.clearOut();
      } else {
        JwtStorageService.setToken(res.data);
        this.$router.push('/dashboard');
      }
    });
  }

  mounted() {
    this.clearOut();
  }
}
